import { axiosInstance } from "../client";
import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";
import { PaginationParams } from "@rumble-it/common-lib/types/api/PaginationParams.interface";
import { Role } from "@rumble-it/common-lib/types/models/Role.interface";
import { User } from "@rumble-it/common-lib/types/models/User.interface";
import { UserFormValues } from "../../../pages/admin/users/components/UserForm";
import { MIME_TYPE_MERGE_PATCH_JSON } from "@rumble-it/common-lib/src/constants/mimeTypes";

export async function fetchUsers(
  params: PaginationParams,
): Promise<CollectionResponse<User>> {
  return axiosInstance
    .get("/users", { params })
    .then((response) => response.data);
}

export const fetchUsersWithoutPagination = async (): Promise<
  CollectionResponse<User>
> => axiosInstance.get(`/admin/users`).then((response) => response.data);

export async function fetchUserById(id: string): Promise<User> {
  return axiosInstance
    .get(`/admin/users/${id}`)
    .then((response) => response.data);
}

export async function createUser(
  payload: Partial<UserFormValues>,
): Promise<User> {
  return axiosInstance
    .post("admin/users", payload)
    .then((response) => response.data);
}

export async function updateUser(
  id: string,
  payload: Partial<UserFormValues>,
): Promise<User> {
  return axiosInstance
    .put(`admin/users/${id}`, payload)
    .then((response) => response.data);
}

export async function updateCurrentUser(
  payload: Partial<UserFormValues>,
): Promise<User> {
  return axiosInstance
    .patch(`current-user`, payload, {
      headers: { "Content-Type": MIME_TYPE_MERGE_PATCH_JSON },
    })
    .then((response) => response.data);
}

export async function fetchUserRoles(): Promise<Role[]> {
  return axiosInstance.get(`/users/roles`).then((response) => response.data);
}

export async function reinviteUser(id: string): Promise<void> {
  return axiosInstance
    .post(`/admin/users/${id}/reinvite`)
    .then((response) => response.data);
}
